module.exports = __webpack_public_path__ + "img/04-B07.ec1f3625.png";